import(/* webpackMode: "eager" */ "/vercel/path0/app/(mitra)/products/hits/page.js")